module.exports = __webpack_public_path__ + "static/media/3.f44018c6.jpeg";